import { createAction } from 'redux-actions';

export interface setBillValueAction {
	payload: {
		billValue: string;
	};
}

export const setBillValue: any = createAction('SET_BILL_VALUE', (billValue: setBillValueAction) => billValue);
export const clearBillValue: any = createAction('CLEAR_BILL_VALUE', () => null);
export const setSelectedBills: any = createAction('SET_SELECTED_BILLS', (selectedBills: any) => {
	return selectedBills;
});
